import React from 'react'
import './style.scss';
const Address = ({color,addressType,full_address,city,state,pincode,mobileNumber}) => {
  return (
    <div className="address-detail-container">
          <p className='icon' style={{color:`var(${color})`}}><i className="fa-solid fa-location-dot"></i></p>
          <div className='address' style={{color:`var(${color})`}}>
          <u><strong>{addressType}</strong></u>
           <p>{full_address},{city},{state} Pincode - {pincode}.</p>
           <p>Mobile - {mobileNumber}</p>
          </div>
          <div className="action-btn">
            <a href={`tel:${mobileNumber}`}>
            <i className="fa-solid fa-phone-volume"></i>
            </a>
            <a className='invisible'>
            <i className="fa-regular fa-comment fa-flip-horizontal"></i>
            </a>
          </div>
        </div>
  )
}

export default Address